var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import FullModal from "@irati/ui/src/FullModal";
import Success from "@irati/ui/src/Success";
import { H1 } from "@irati/ui/src/Typography";
import Button from "@irati/ui/src/Button";
import id from "@irati/utils/id";
import SettingsTile from "../../SettingsTile";
import Modal from "./Modal/Modal";
var PerkVisibility = /** @class */ (function (_super) {
    __extends(PerkVisibility, _super);
    function PerkVisibility() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            show: false,
            updated: false,
            saved: false
        };
        _this.toggleShow = function () {
            _this.setState({ show: !_this.state.show });
        };
        _this.handleSave = function () {
            _this.setState({ updated: true });
        };
        _this.handleHide = function () {
            _this.setState(function (state) {
                var saved = state.updated;
                if (saved) {
                    setTimeout(function () {
                        _this.setState({
                            updated: false,
                            saved: false
                        });
                    }, 7000);
                }
                return {
                    show: false,
                    saved: saved
                };
            });
            var onModalClose = _this.props.onModalClose;
            if (onModalClose)
                onModalClose();
        };
        _this.hideSavedPopUp = function () {
            _this.setState({
                saved: false,
                updated: false
            });
        };
        return _this;
    }
    PerkVisibility.prototype.render = function () {
        var formatMessage = this.props.formatMessage;
        var idNamespace = id("company-settings-title", this.props);
        return (React.createElement(React.Fragment, null,
            React.createElement(H1, { margin: "0 0 24px" }, formatMessage({ id: "admin.components.perkVisibility.title" })),
            React.createElement(SettingsTile, { title: "admin.components.perkVisibility.companySettingsTitle.title", value: "admin.components.perkVisibility.companySettingsTitle.value" },
                React.createElement(Button, { id: id("btn-change", idNamespace), onClick: this.toggleShow, small: true },
                    React.createElement(FormattedMessage, { id: "admin.components.companySettingsTitle.button.change" }))),
            this.state.show && React.createElement(Modal, { onSave: this.handleSave, onHide: this.handleHide }),
            this.state.saved && (React.createElement(FullModal, { show: true, onHide: this.hideSavedPopUp },
                React.createElement(Success, { message: formatMessage({ id: "admin.components.perkVisibility.success.message" }) })))));
    };
    return PerkVisibility;
}(Component));
export default injectIntl(PerkVisibility);
